var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_c('div',{class:this.$store.getters.auth_token != null ? 'with-menu' : 'without-menu'},[_c('span',[_vm._v(" Lo sentimos, la página que estás buscando no se pudo encontrar. ")]),_c('router-link',{attrs:{"to":"/empresas"}},[_vm._v(" Ir a inicio ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }